module.exports = "./img/5d13df048e64ceac1e8a1289fa00a6c9.jpg";